import moment from "moment";
import { useToggle } from "react-use";
import GenderInput from "../user/GenderInput";
import BirthDateInput from "../user/BirthDateInput";
import SchoolInput from "../user/SchoolInput";
import { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { updateUserInfo } from "../../api";

const MyInfoPersonal = ({ data }) => {
  const queryClient = useQueryClient();
  const [on, toggle] = useToggle(false);
  const [error, setError] = useState(null);
  const [{ gender, birth_date, school }, setData] = useState({ ...data });

  const { mutate: updateMutation } = useMutation({
    mutationFn: updateUserInfo,
    onSettled: (result) => {
      if (result && result.result) {
        toggle();
      }
      setError(result.error);
      queryClient.invalidateQueries({ queryKey: ["user/update"] });
    },
  });

  const handleUpdate = () => {
    updateMutation({ id: data.user_id, birth_date, gender, school });
  };

  const onChange = (e) => {
    const { value: val, id: target } = e.target;
    if (target === "birth_date" || target === "school") {
      setData({ gender, birth_date, school, [target]: val });
    } else {
      const [k, v] = target.split("_");
      setData({ birth_date, school, [k]: v.toUpperCase() });
    }
  };

  useEffect(() => {
    if (!on) {
      setError(null);
    }
  }, [on]);

  return (
    <div className="flex flex-col justify-center mt-2 border rounded-xl pb-2 px-4 gap-2 w-full">
      <div
        className={`inline-flex items-center justify-between mt-1 swap ${
          on && "swap-active"
        }`}
      >
        <label className="label font-bold text-primary">개인 정보</label>
        {!on && (
          <button
            className={`btn btn-primary btn-outline btn-sm min-h-[2rem] swap-off ${
              on && "hidden"
            }`}
            onClick={toggle}
          >
            변경
          </button>
        )}
      </div>
      <div className="inline-flex items-center gap-2 min-h-[2rem]">
        <label className="text-sm font-bold w-16 text-end">성별</label>
        {!on && (
          <span className={`swap-on ${on && "hidden"}`}>
            {gender ? (gender === "M" ? "남성" : "여성") : "-"}
          </span>
        )}
        {on && (
          <div className={`flex flex-col justify-start w-full md:w-2/3`}>
            <GenderInput {...{ gender, onChange, className: `h-10 text-sm` }} />
          </div>
        )}
      </div>
      <div className="inline-flex items-center gap-2 min-h-[2rem]">
        <label className="text-sm font-bold w-16 text-end">생년월일</label>
        {!on && (
          <span>
            {birth_date ? moment(birth_date).format("YYYY-MM-DD") : "-"}
          </span>
        )}
        {on && (
          <div className={`flex flex-col justify-start w-full md:w-2/3`}>
            <BirthDateInput
              {...{
                birth_date: moment(birth_date).format("YYYY-MM-DD"),
                onChange,
                className: "h-10",
              }}
            />
          </div>
        )}
      </div>
      <div className="inline-flex items-center gap-2 min-h-[2rem]">
        <label className="text-sm font-bold w-16 text-end">학교</label>
        {!on && <span>{school.name || "-"}</span>}
        {on && (
          <div className={`flex flex-col justify-start w-full md:w-2/3 gap-1`}>
            <SchoolInput
              {...{
                school: school,
                onChange,
                setError,
                className: "h-10 min-h-min",
              }}
            />
          </div>
        )}
      </div>
      {!!error && (
        <span className="text-sm text-left text-red-500 mb-2">{error}</span>
      )}
      {on && (
        <div className="inline-flex items-center gap-2 w-full ml-[4.5rem] md:w-2/3">
          <div className="inline-flex gap-2 w-full">
            <button className="btn btn-sm flex-none" onClick={toggle}>
              취소
            </button>
            <button
              className="btn btn-primary btn-sm flex-auto"
              onClick={handleUpdate}
            >
              변경
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MyInfoPersonal;
